const prefix1a = 'fundManagers/';
const prefix1b = 'providers/';
const prefix2 = 'securityIDTypes/';
const prefix3 = 'securityIDs/';
export const typeIDToName = ({ parentName, securityIDType }) => {
    return parentName + '/' + prefix2 + securityIDType;
};
export const typeNameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 4 || (!name.startsWith(prefix1a) && !name.startsWith(prefix1b)) || !name.includes(prefix2)) {
        throw new Error(`bad custom security ID type name: ${name}`);
    }
    return { parentName: parts.slice(0, 2).join('/'), securityIDType: parts[3] };
};
export const IDToName = ({ parentName, securityIDType, securityID }) => {
    return parentName + '/' + prefix2 + securityIDType + '/' + prefix3 + securityID;
};
export const nameIsCustomName = (name) => {
    const parts = name.split('/');
    return (parts.length === 6 &&
        (name.startsWith(prefix1a) || name.startsWith(prefix1b)) &&
        name.includes(prefix2) &&
        name.includes(prefix3));
};
export const nameToID = (name) => {
    if (!nameIsCustomName(name)) {
        throw new Error(`bad custom security ID name: ${name}`);
    }
    const parts = name.split('/');
    return { parentName: parts.slice(0, 2).join('/'), securityIDType: parts[3], securityID: parts[5] };
};
export const wildcardParentName = prefix1a + '-/' + prefix2 + '-';
export const IDToLabel = ({ securityIDType, securityID }) => {
    return `${securityIDType}: ${securityID}`;
};
export const toOption = (title, name) => {
    return {
        label: title + ': ' + typeNameToID(name).securityIDType,
        value: name,
    };
};
